import { memo } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface ConfirmCancelDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

const ConfirmCancelDialog = memo(
  ({ isOpen, onOpenChange, onConfirm }: ConfirmCancelDialogProps) => {
    return (
      <Dialog open={isOpen} onOpenChange={onOpenChange}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle className="text-center">تأكيد الإغلاق</DialogTitle>
            <DialogDescription className="text-center">
              هل تريد إلغاء الطلب وفقدان جميع البيانات المدخلة؟
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="flex items-center justify-center gap-2 sm:justify-center">
            <Button
              variant="destructive"
              onClick={() => {
                onConfirm();
                onOpenChange(false);
              }}
            >
              نعم، إلغاء الطلب
            </Button>
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              لا، استمرار التعديل
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  },
);

ConfirmCancelDialog.displayName = 'ConfirmCancelDialog';

export default ConfirmCancelDialog;
